import React from "react";
import { useTranslation } from "react-i18next";
import { Page } from "shared/ui";
import TaskCalendar from "./TaskCalendar";

const TaskHubUserCalendar = () => {
  const { t } = useTranslation();

  return (
    <Page title={t("taskHub.schedule.taskHubSchedule") || "Task Hub Schedule"}>
      <TaskCalendar mode="executions" />
    </Page>
  );
};

export { TaskHubUserCalendar };
